export default "__VITE_ASSET__DVprxvgz__"